import React from 'react'
import {
    Form,
    Select,
} from 'antd'

const { Option } = Select

function Component(
    {
        layout,
        disabled,

        label = 'โครงการ/สังกัด',
        name = 'author',

        options,
        value,
        onChange,
    }
)
{
    return (
        <Form.Item 
            {...layout}
            label={label}
        >
            <Select 
                disabled={disabled}
                value={value}
                onChange={option => onChange(name, option)}
            >
                {
                    options.map(option =>
                    {
                        return (
                            <Option
                                key={`overview-author-${option.value}`}
                                value={option.value}
                            >
                                {option.text}
                            </Option>
                        )  
                    })
                }
            </Select>
        </Form.Item>
    )
}

export default Component